import Vue from 'vue';
import VueFlagIcon from 'vue-flag-icon';

Vue.use(VueFlagIcon);
